var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C9 13.163 8.73661 13.7989 8.26777 14.2678C7.79893 14.7366 7.16304 15 6.5 15C5.83696 15 5.20107 14.7366 4.73223 14.2678C4.26339 13.7989 4 13.163 4 12.5C4 11.837 4.26339 11.2011 4.73223 10.7322C5.20107 10.2634 5.83696 10 6.5 10C7.16304 10 7.79893 10.2634 8.26777 10.7322C8.73661 11.2011 9 11.837 9 12.5Z",
    stroke: "#3B3B58",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7L9 10.5M14 18L9 14.5",
    stroke: "#3B3B58",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19C19 19.663 18.7366 20.2989 18.2678 20.7678C17.7989 21.2366 17.163 21.5 16.5 21.5C15.837 21.5 15.2011 21.2366 14.7322 20.7678C14.2634 20.2989 14 19.663 14 19C14 18.337 14.2634 17.7011 14.7322 17.2322C15.2011 16.7634 15.837 16.5 16.5 16.5C17.163 16.5 17.7989 16.7634 18.2678 17.2322C18.7366 17.7011 19 18.337 19 19ZM19 6C19 6.66304 18.7366 7.29893 18.2678 7.76777C17.7989 8.23661 17.163 8.5 16.5 8.5C15.837 8.5 15.2011 8.23661 14.7322 7.76777C14.2634 7.29893 14 6.66304 14 6C14 5.33696 14.2634 4.70107 14.7322 4.23223C15.2011 3.76339 15.837 3.5 16.5 3.5C17.163 3.5 17.7989 3.76339 18.2678 4.23223C18.7366 4.70107 19 5.33696 19 6Z",
    stroke: "#3B3B58",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.748ea49c1cb52da2b848659c38bc808a.svg";
export { ForwardRef as ReactComponent };